export default __webpack_public_path__ + "static/media/889.4912810e.gif";